import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import trainingCenterService from "services/Training/TrainingCenterService";
// import { cloneDeep } from "lodash";
import SignatureProcessService from "services/SignatureProcessService";

export const getDocumentSetting = createAsyncThunk(
  "documentSettingSlice/getDocumentSetting",
  async (data, { rejectWithValue }) => {
    try {
      const response = await SignatureProcessService.getSettingDocuments(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateDocumentSetting = createAsyncThunk(
  "documentSettingSlice/updateDocumentSetting",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const response = await SignatureProcessService.updateDocumentSetting(data);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      console.error("API call failed:", error);
      return rejectWithValue(error.message || "Error");
    }
  }
);

const initialState = {
  loading: null,
  data: null,
};

const documentSettingSlice = createSlice({
  name: "documentSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocumentSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDocumentSetting.rejected, (state, action) => {
        state.loading = false;
      })
     
      .addCase(updateDocumentSetting.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDocumentSetting.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDocumentSetting.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default documentSettingSlice.reducer;
